import React, { ReactElement } from "react";

/** No error list b/c Polaris uses in-form errors. */
export default function ErrorListTemplate(): ReactElement {
  return <></>;
}
